import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class stdClassDataService {
  // 获取实体数据管理动态表头
  static async getDynamicTableHeader(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/dynamic-table-header-info?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取实体数据管理动态表数据
  static async getDynamicTableData(payload, query) {
    RecordOperation({ type: 'query' })
    if (!query) {
      const [err, res] = await To(
        wizStandardInstance.post('/api/std/StdClassData/dynamic-table-paged-result', payload)
      )
      return Callback(err, res)
    }
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/StdClassData/dynamic-table-paged-result-advance-query',
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取页码数量
  static async getPagedCount(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/dynamic-table-paged-count', payload)
    )
    return Callback(err, res)
  }
  static async getValueList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/attribute?id=${payload.id}`)
    )
    return Callback(err, res)
  }
  static async getcode(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/code/generate', payload)
    )
    return Callback(err, res)
  }
  static async save(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/code/save', payload)
    )
    return Callback(err, res)
  }
  static async query(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/query?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getInsertData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/get_insert_data?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getColumnData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/get_column_data?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getRefrenceData(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/get_refrence_data?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async insertDataDetail(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/insert_data_detail', payload)
    )
    return Callback(err, res)
  }
  static async updateDataDetail(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/update_data_detail', payload)
    )
    return Callback(err, res)
  }
  static async deleteDataDetail(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance.delete(
        `/api/std/StdClassData/delete_data_detail?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getDataById(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/get_data_by_id?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async exportData(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/export?${qs.stringify(payload)}`, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }

  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdClassData/code', payload))
    return Callback(err, res)
  }
  static async view(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/lifetime?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async node(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/node?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async group(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/group?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async statistics(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/statistics?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async dict(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/class/dict?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async serial(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/serial?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async inherit(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/inherit?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getTagAttrList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataLabel/get_tag_attr_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取个人的收藏夹内容
  static async getCollection(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Favorite/favorite-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 收藏自己的内容
  static async updateCollection(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Favorite/favorite-owner', payload)
    )
    return Callback(err, res)
  }
}
